import { Link, NavLink } from "react-router-dom";
import { GraduationCap, Menu, X, Lock } from "lucide-react";
import { useState } from "react";
import { cn } from "../lib/utils";
import { ESCUELAS_LIST } from "../data/escuelas";

export default function Navbar() {
    const [open, setOpen] = useState(false);

    return (
        <header
            data-testid="navbar"
            className="fixed top-0 inset-x-0 z-50 bg-white/85 backdrop-blur-xl border-b border-slate-200/60"
        >
            <div className="max-w-7xl mx-auto h-20 px-6 md:px-10 flex items-center justify-between gap-6">
                <Link
                    to="/"
                    data-testid="navbar-logo"
                    className="flex items-center gap-3 group flex-shrink-0"
                >
                    <span className="grid place-items-center w-10 h-10 rounded-xl bg-unemi-blue-primary text-white shadow-md shadow-unemi-blue-primary/20 group-hover:bg-unemi-blue-dark transition-colors">
                        <GraduationCap className="w-5 h-5" />
                    </span>
                    <div className="leading-tight">
                        <p className="font-heading text-lg font-semibold text-unemi-blue-dark">
                            UNEMI
                        </p>
                        <p className="text-[10px] uppercase tracking-[0.2em] text-unemi-orange-primary font-bold">
                            Posgrados
                        </p>
                    </div>
                </Link>

                <nav className="hidden xl:flex items-center gap-1">
                    {ESCUELAS_LIST.map((e) => (
                        <NavLink
                            key={e.slug}
                            to={`/${e.slug}`}
                            data-testid={`nav-link-${e.slug}`}
                            className={({ isActive }) =>
                                cn(
                                    "px-3 py-2 rounded-full text-xs font-semibold transition-all flex items-center gap-1.5",
                                    isActive
                                        ? "bg-unemi-blue-primary text-white"
                                        : "text-unemi-blue-primary hover:bg-slate-100",
                                    !e.activa && "opacity-50"
                                )
                            }
                        >
                            {!e.activa && <Lock className="w-3 h-3" />}
                            {e.nombreCorto}
                        </NavLink>
                    ))}
                </nav>

                <a
                    href="#contacto"
                    data-testid="nav-cta-contacto"
                    className="hidden md:inline-flex items-center gap-2 h-11 px-6 rounded-full bg-unemi-orange-primary text-white font-bold text-sm hover:bg-unemi-orange-primary/90 shadow-lg shadow-unemi-orange-primary/25 transition-all flex-shrink-0"
                >
                    Inscríbete
                </a>

                <button
                    data-testid="navbar-mobile-toggle"
                    onClick={() => setOpen(!open)}
                    className="xl:hidden grid place-items-center w-10 h-10 rounded-lg text-unemi-blue-primary hover:bg-slate-100"
                >
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>
            </div>

            {open && (
                <div
                    data-testid="navbar-mobile-menu"
                    className="xl:hidden border-t border-slate-200 bg-white animate-fade-in"
                >
                    <nav className="px-6 py-4 flex flex-col gap-1">
                        {ESCUELAS_LIST.map((e) => (
                            <NavLink
                                key={e.slug}
                                to={`/${e.slug}`}
                                onClick={() => setOpen(false)}
                                className={({ isActive }) =>
                                    cn(
                                        "flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-semibold",
                                        isActive
                                            ? "bg-unemi-blue-primary text-white"
                                            : "text-unemi-blue-primary hover:bg-slate-100",
                                        !e.activa && "opacity-50"
                                    )
                                }
                            >
                                {!e.activa && <Lock className="w-4 h-4" />}
                                {e.nombreCorto}
                            </NavLink>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
